module.exports = __webpack_public_path__ + "img/pro_capture13.7737a244.png";